const FILTER_API_ENDPOINT = window.apiUrl + "/api/product/filter";

// ===== JUDGE.ME API INTEGRATION =====

// Judge.me API configuration
const JUDGE_ME_CONFIG = {
  shopDomain: window.shopDomain,
  judgemeApiPublicToken: window.judgemeApiPublicToken,
};

// ===== FAVOURITES FUNCTIONALITY =====

// Toggle favourite status using common functionality
async function toggleFavourite() {
  const addToFavoritesBtn = document.getElementById("add-to-favorites-btn");

  if (!addToFavoritesBtn) {
    return;
  }

  // Get access token using common function
  const customerAccessToken = JSON.parse(
    localStorage.getItem(window.customerAccessTokenKey),
  );
  const accessToken = customerAccessToken
    ? customerAccessToken.accessToken
    : null;

  if (!accessToken) {
    // User not logged in - show login modal
    const loginModal = new bootstrap.Modal(
      document.getElementById("confirmLoginModal"),
    );
    loginModal.show();
    return;
  }

  const productId = `gid://shopify/Product/${window.PRODUCT_DATA?.id}`;
  const numericProductId = String(window.PRODUCT_DATA?.id);

  if (!productId || !numericProductId) {
    return;
  }

  // Disable button to prevent spam clicks
  addToFavoritesBtn.disabled = true;

  // Update button text/icon based on screen size
  const favoriteText = addToFavoritesBtn.querySelector(".favorite-text");
  if (window.innerWidth <= 768) {
    // Mobile: hide text, show loading state on icon
    if (favoriteText) {
      favoriteText.style.display = "none";
    }
  } else {
    // Desktop: show text
    if (favoriteText) {
      favoriteText.textContent = "処理中...";
    }
  }

  try {
    // トークンは Authorization ヘッダーでも送る。今のバックエンドは body の accessToken を読むので、body からはまだ外さない
    const response = await fetch(FAVOURITES_API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      mode: "cors",
      body: JSON.stringify({
        accessToken,
        productId,
      }),
    });

    const result = await response.json();

    if (result.success) {
      // Update localStorage cache based on API response (same logic as common file)
      const ids = new Set(loadFavouriteIds().map(String));

      if (result.data.action === "added") {
        ids.add(numericProductId);
        addToFavoritesBtn.classList.add("favourite-active");
        if (favoriteText) {
          favoriteText.textContent = "お気に入りから削除";
        }
      } else {
        ids.delete(numericProductId);
        addToFavoritesBtn.classList.remove("favourite-active");
        if (favoriteText) {
          favoriteText.textContent = "お気に入りに追加";
        }
      }

      // Save updated cache to localStorage using common function
      saveFavouriteIds(Array.from(ids));
    } else {
      addToFavoritesBtn.classList.remove("favourite-active");
      if (favoriteText) {
        favoriteText.textContent = "お気に入りに追加";
      }
    }
  } catch (error) {
    addToFavoritesBtn.classList.remove("favourite-active");
    if (favoriteText) {
      favoriteText.textContent = "お気に入りに追加";
    }
  } finally {
    // Re-enable button and restore text visibility
    addToFavoritesBtn.disabled = false;
    if (favoriteText) {
      favoriteText.style.display = "";
    }
  }
}

// Check initial favourite status using common functions
function checkInitialFavouriteStatus() {
  const addToFavoritesBtn = document.getElementById("add-to-favorites-btn");

  if (!addToFavoritesBtn) {
    return;
  }

  // Get 製品ID in numeric format for localStorage comparison
  const productId = String(window.PRODUCT_DATA?.id);
  if (!productId) {
    return;
  }

  // Use common function to check if product is favorited
  const cachedIds = new Set(loadFavouriteIds().map(String));
  const isFavourite = cachedIds.has(productId);

  // Update button state based on cache
  const favoriteText = addToFavoritesBtn.querySelector(".favorite-text");
  if (isFavourite) {
    addToFavoritesBtn.classList.add("favourite-active");
    if (favoriteText) {
      favoriteText.textContent = "お気に入りから削除";
    }
  } else {
    addToFavoritesBtn.classList.remove("favourite-active");
    if (favoriteText) {
      favoriteText.textContent = "お気に入りに追加";
    }
  }
}

// Update custom pagination counter
function updateCustomPaginationCounter(currentSlide) {
  const currentSlideElement = document.querySelector(
    ".custom-pagination-counter .current-slide",
  );
  if (currentSlideElement) {
    currentSlideElement.textContent = currentSlide;
  }
}

// Track current slide for pagination counter
let currentSlideIndex = 1;

// Function to check and update pagination counter
function checkSlideChange() {
  const mainSlider = document.querySelector(".product-image-slider");
  if (mainSlider && mainSlider.swiper) {
    const activeIndex = mainSlider.swiper.activeIndex;
    const newSlideNumber = activeIndex + 1;

    if (newSlideNumber !== currentSlideIndex) {
      currentSlideIndex = newSlideNumber;
      updateCustomPaginationCounter(newSlideNumber);
    }
  }
}

// Load Judge.me reviews on DOM ready
document.addEventListener("DOMContentLoaded", function () {
  checkInitialFavouriteStatus();
  loadJudgeMeReviews();

  // Handle window resize to update button display
  window.addEventListener("resize", function () {
    checkInitialFavouriteStatus();
  });

  // Initialize custom pagination counter
  setTimeout(() => {
    updateCustomPaginationCounter(1);
  }, 500);

  // Start monitoring slide changes
  setInterval(checkSlideChange, 100);
});

async function loadJudgeMeReviews() {
  try {
    // Get product handle from current page
    const productId = getProductHandle();
    if (!productId) {
      displayError();
      return;
    }

    // API endpoint for product reviews
    const apiUrl = `https://judge.me/api/v1/widgets/product_review?shop_domain=${JUDGE_ME_CONFIG.shopDomain}&api_token=${JUDGE_ME_CONFIG.judgemeApiPublicToken}&handle=${productId}`;

    const response = await fetch(apiUrl);
    const data = await response.json();

    if (data && data.widget) {
      // Parse HTML widget and reorganize structure
      parseAndReorganizeWidget(data.widget);
    } else {
      displayNoReviews();
    }
  } catch (error) {
    displayError();
  }
}

function parseAndReorganizeWidget(htmlWidget) {
  const container = document.getElementById("judgeme_product_reviews");

  // Create temporary container to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlWidget;

  // Find all review elements
  const reviews = tempDiv.querySelectorAll(".jdgm-rev");

  if (reviews.length === 0) {
    displayNoReviews();
    return;
  }

  // Clear container
  container.innerHTML = "";

  // Process each review
  reviews.forEach((review) => {
    const reorganizedReview = reorganizeReviewStructure(review);
    container.appendChild(reorganizedReview);
  });

  // Hide load more button if we have fewer than 5 reviews (likely all reviews)
  if (reviews.length < 5) {
    hideLoadMoreButton();
  }
}

// Extract images from [IMG] tags in review body
function extractImagesFromBody(bodyText) {
  if (!bodyText) return [];

  const imageRegex = /\[IMG\](.*?)\[\/IMG\]/g;
  const extractedImages = [];
  let match;

  while ((match = imageRegex.exec(bodyText)) !== null) {
    extractedImages.push(match[1].trim());
  }

  return extractedImages;
}

// Clean review body by removing [IMG] tags
function cleanReviewBody(bodyText) {
  if (!bodyText) return "";

  return bodyText
    .replace(/\[IMG\](.*?)\[\/IMG\]/g, "") // Remove [IMG] tags
    .replace(/\n{3,}/g, "\n\n") // Clean up extra newlines
    .trim(); // Remove leading/trailing whitespace
}

function reorganizeReviewStructure(originalReview) {
  // Create main container (Frame 315)
  const reviewDiv = document.createElement("div");
  reviewDiv.className = "jdgm-rev-custom";

  // Extract elements from original review
  const author = originalReview.querySelector(".jdgm-rev__author");
  const rating = originalReview.querySelector(".jdgm-rev__rating");
  const title = originalReview.querySelector(".jdgm-rev__title");
  const body = originalReview.querySelector(".jdgm-rev__body");
  const timestamp = originalReview.querySelector(".jdgm-rev__timestamp");
  const productLink = originalReview.querySelector(".jdgm-rev__prod-link");
  const pics = originalReview.querySelector(".jdgm-rev__pics");

  // Extract images from body [IMG] tags and clean the body
  let bodyText = "";
  let extractedImages = [];
  if (body && body.textContent) {
    bodyText = body.textContent;
    extractedImages = extractImagesFromBody(bodyText);
    bodyText = cleanReviewBody(bodyText);
  }

  // Frame 1261153458: Author + Product info row (Row 1)
  const authorProductFrame = document.createElement("div");
  authorProductFrame.className = "jdgm-rev__author-product-frame";

  // Frame 200: Author name + Mobile Rating
  const authorFrame = document.createElement("div");
  authorFrame.className = "jdgm-rev__author-frame";
  if (author) {
    const authorClone = author.cloneNode(true);
    authorFrame.appendChild(authorClone);
  }

  // Mobile rating (hidden on desktop, shown on mobile)
  if (rating) {
    const mobileRatingFrame = document.createElement("div");
    mobileRatingFrame.className = "jdgm-rev__rating-mobile";

    const mobileRatingClone = rating.cloneNode(true);
    mobileRatingFrame.appendChild(mobileRatingClone);
    authorFrame.appendChild(mobileRatingFrame);
  }

  // Product info (for product page, we can show the current product name)
  const productFrame = document.createElement("div");
  productFrame.className = "jdgm-rev__product-frame";
  if (productLink) {
    const productClone = productLink.cloneNode(true);
    productClone.textContent = `(${productClone.textContent.trim()})`;
    productFrame.appendChild(productClone);
  } else if (window.PRODUCT_DATA && window.PRODUCT_DATA.title) {
    // For product page, show current product name
    const productElement = document.createElement("span");
    productElement.textContent = `(${window.PRODUCT_DATA.title})`;
    productFrame.appendChild(productElement);
  }

  authorProductFrame.appendChild(authorFrame);
  authorProductFrame.appendChild(productFrame);

  // Frame 1795: Content wrapper (Row 2)
  const contentFrame = document.createElement("div");
  contentFrame.className = "jdgm-rev__content-frame";

  // Frame 208: Rating + Title row (same line)
  const ratingTitleFrame = document.createElement("div");
  ratingTitleFrame.className = "jdgm-rev__rating-title-frame";

  // Frame 207: Desktop Rating stars
  const ratingFrame = document.createElement("div");
  ratingFrame.className = "jdgm-rev__rating-frame jdgm-rev__rating-desktop";

  if (rating) {
    const desktopRatingClone = rating.cloneNode(true);
    ratingFrame.appendChild(desktopRatingClone);
  }

  // Add rating frame first
  ratingTitleFrame.appendChild(ratingFrame);

  // Title (same line as rating) - use existing title or first sentence
  if (title && title.textContent.trim()) {
    const titleElement = document.createElement("span");
    titleElement.className = "jdgm-rev__title";
    titleElement.textContent = title.textContent.trim();
    ratingTitleFrame.appendChild(titleElement);
  } else if (bodyText && bodyText.trim()) {
    const firstSentence =
      bodyText.split(".")[0] + (bodyText.includes(".") ? "." : "");
    const titleElement = document.createElement("span");
    titleElement.className = "jdgm-rev__title";
    titleElement.textContent = firstSentence;
    ratingTitleFrame.appendChild(titleElement);
  }

  contentFrame.appendChild(ratingTitleFrame);

  // Review content (separate line) - use cleaned body text
  if (bodyText && bodyText.trim()) {
    const bodyElement = document.createElement("div");
    bodyElement.className = "jdgm-rev__body";
    bodyElement.textContent = bodyText;
    contentFrame.appendChild(bodyElement);
  }

  // Build main structure
  reviewDiv.appendChild(authorProductFrame);
  reviewDiv.appendChild(contentFrame);

  // Frame 1261153462: Image gallery (if exists) - AFTER content
  // Merge images from both sources: original pics and extracted images from body
  const allImages = [];

  // Collect images from original pics container
  if (pics && pics.children.length > 0) {
    Array.from(pics.children).forEach((img) => {
      let imageUrl = "";

      if (img.tagName === "A") {
        // If it's a link, get the img inside
        const innerImg = img.querySelector("img");
        if (innerImg) {
          imageUrl = innerImg.getAttribute("data-src") || innerImg.src;
        }
      } else if (img.tagName === "IMG") {
        // If it's directly an img element
        imageUrl = img.getAttribute("data-src") || img.src;
      }

      if (imageUrl) {
        allImages.push(imageUrl);
      }
    });
  }

  // Add extracted images from body [IMG] tags
  if (extractedImages.length > 0) {
    allImages.push(...extractedImages);
  }

  // Create image gallery if we have any images
  if (allImages.length > 0) {
    const imageGalleryFrame = document.createElement("div");
    imageGalleryFrame.className = "jdgm-rev__image-gallery";

    allImages.forEach((imageUrl) => {
      const imageFrame = document.createElement("div");
      imageFrame.className = "jdgm-rev__image-frame";

      const newImg = document.createElement("img");
      newImg.src = imageUrl;
      newImg.alt = "レビュー画像";
      newImg.className = "jdgm-rev__pic-img";

      // Add error handling for broken images
      newImg.onerror = function () {
        this.style.display = "none";
      };

      imageFrame.appendChild(newImg);
      imageGalleryFrame.appendChild(imageFrame);
    });

    reviewDiv.appendChild(imageGalleryFrame);
  }

  // Timestamp (separate element at bottom)
  if (timestamp) {
    const timestampClone = document.createElement("div");
    timestampClone.className = "jdgm-rev__timestamp-frame";
    timestampClone.textContent = formatTimestamp(
      timestamp.getAttribute("data-content"),
    );
    reviewDiv.appendChild(timestampClone);
  }

  return reviewDiv;
}

function formatTimestamp(timestampString) {
  if (!timestampString) return "";

  try {
    // Debug log to see actual data

    // Normalize to ISO 8601: YYYY-MM-DDTHH:mm:ssZ
    let isoString = timestampString.trim();

    // Handle different formats and normalize to ISO 8601
    if (isoString.includes(" UTC")) {
      // Format: "2024-01-15 10:30:00 UTC" -> "2024-01-15T10:30:00Z"
      isoString = isoString.replace(" UTC", "Z").replace(" ", "T");
    } else if (isoString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
      // Format: "2024-01-15 10:30:00" -> "2024-01-15T10:30:00Z"
      isoString = isoString.replace(" ", "T") + "Z";
    } else if (isoString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
      // Format: "2024-01-15T10:30:00" -> "2024-01-15T10:30:00Z"
      isoString = isoString + "Z";
    } else if (isoString.match(/^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/)) {
      // Format: "2024/01/15 10:30:00" -> "2024-01-15T10:30:00Z"
      isoString = isoString.replace(/\//g, "-").replace(" ", "T") + "Z";
    } else if (isoString.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
      // Format: "2024/01/15" -> "2024-01-15T00:00:00Z"
      isoString = isoString.replace(/\//g, "-") + "T00:00:00Z";
    } else if (isoString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Format: "2024-01-15" -> "2024-01-15T00:00:00Z"
      isoString = isoString + "T00:00:00Z";
    } else if (isoString.match(/^\d{10}$/)) {
      // Unix timestamp (seconds) -> ISO 8601
      const date = new Date(parseInt(isoString) * 1000);
      isoString = date.toISOString();
    } else if (isoString.match(/^\d{13}$/)) {
      // Unix timestamp (milliseconds) -> ISO 8601
      const date = new Date(parseInt(isoString));
      isoString = date.toISOString();
    } else {
      // Fallback: add UTC suffix and normalize
      isoString = isoString + " UTC";
      isoString = isoString.replace(" UTC", "Z").replace(" ", "T");
    }

    // Parse with normalized ISO 8601
    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      return "日付不明";
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    // Kiểm tra các thành phần có hợp lệ không
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return "日付不明";
    }

    const result = `${year}年${month}月${day}日`;
    return result;
  } catch (error) {
    console.warn(
      "Error in formatTimestamp:",
      error,
      "for input:",
      timestampString,
    );
    return "日付不明";
  }
}

function displayNoReviews() {
  const container = document.getElementById("judgeme_product_reviews");
  if (container) {
    container.innerHTML = '<div class="no-reviews">レビューがありません</div>';
  }
  // Hide load more button when no reviews
  hideLoadMoreButton();
}

function displayError() {
  const container = document.getElementById("judgeme_product_reviews");
  if (container) {
    container.innerHTML =
      '<div class="reviews-error">レビューの読み込み中にエラーが発生しました</div>';
  }
  // Hide load more button when error occurs
  hideLoadMoreButton();
}

// Load more reviews function
async function loadMoreReviews() {
  try {
    const productId = getProductHandle();
    if (!productId) {
      return;
    }

    // Get current number of reviews to calculate per_page
    const currentReviews = document.querySelectorAll(".jdgm-rev-custom");
    const currentCount = currentReviews.length;
    const perPage = currentCount + 1; // Increase per_page by 1 each time

    // API endpoint with append and increasing per_page
    const apiUrl = `https://judge.me/api/v1/widgets/product_review?shop_domain=${JUDGE_ME_CONFIG.shopDomain}&api_token=${JUDGE_ME_CONFIG.judgemeApiPublicToken}&handle=${productId}&per_page=${perPage}`;

    const response = await fetch(apiUrl);
    const data = await response.json();

    if (data && data.widget) {
      // Parse HTML widget and append new reviews
      appendMoreReviews(data.widget);
    } else {
      // Hide load more button if no more reviews
      hideLoadMoreButton();
    }
  } catch (error) {
    hideLoadMoreButton();
  }
}

function appendMoreReviews(htmlWidget) {
  const container = document.getElementById("judgeme_product_reviews");

  // Get current number of reviews before adding new ones
  const currentReviews = document.querySelectorAll(".jdgm-rev-custom");
  const currentCount = currentReviews.length;

  // Create temporary container to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlWidget;

  // Find all review elements
  const reviews = tempDiv.querySelectorAll(".jdgm-rev");

  if (reviews.length === 0) {
    hideLoadMoreButton();
    return;
  }

  // Only add new reviews (skip the ones we already have)
  const newReviews = Array.from(reviews).slice(currentCount);

  if (newReviews.length === 0) {
    hideLoadMoreButton();
    return;
  }

  // Process each new review
  newReviews.forEach((review) => {
    const reorganizedReview = reorganizeReviewStructure(review);
    container.appendChild(reorganizedReview);
  });

  // Hide load more button if no new reviews were added
  if (newReviews.length === 0) {
    hideLoadMoreButton();
  }
}

function hideLoadMoreButton() {
  const loadMoreContainer = document.querySelector(".reviews-load-more");
  if (loadMoreContainer) {
    loadMoreContainer.style.display = "none";
  }
}

// ===== END JUDGE.ME API INTEGRATION =====

function reorganizeJudgeMeStructure() {
  const reviews = document.querySelectorAll(".jdgm-rev");

  reviews.forEach(function (review) {
    // Get elements
    const author = review.querySelector(".jdgm-rev__author");
    const rating = review.querySelector(".jdgm-rev__rating");
    const title = review.querySelector(".jdgm-rev__title");
    const content = review.querySelector(".jdgm-rev__body");
    const timestamp = review.querySelector(".jdgm-rev__timestamp");

    if (author && rating && content && timestamp) {
      // Create new structure
      const newStructure = document.createElement("div");
      newStructure.className = "jdgm-rev-custom";

      // Header with author name
      const header = document.createElement("div");
      header.className = "jdgm-rev__author-wrapper";
      header.appendChild(author.cloneNode(true));

      // Content wrapper
      const contentWrapper = document.createElement("div");
      contentWrapper.className = "jdgm-rev__content-wrapper";

      // Rating + Title row
      const ratingTitleRow = document.createElement("div");
      ratingTitleRow.className = "jdgm-rev__rating-title-row";
      if (rating) ratingTitleRow.appendChild(rating.cloneNode(true));
      if (title) ratingTitleRow.appendChild(title.cloneNode(true));

      // Add rating+title row to content wrapper
      contentWrapper.appendChild(ratingTitleRow);

      // Add content to wrapper
      if (content) contentWrapper.appendChild(content.cloneNode(true));

      // Add timestamp
      if (timestamp) contentWrapper.appendChild(timestamp.cloneNode(true));

      // Build new structure
      newStructure.appendChild(header);
      newStructure.appendChild(contentWrapper);

      // Replace original review
      review.parentNode.replaceChild(newStructure, review);
    }
  });
}

// Function to calculate day of week based on delivery days
function calculateDeliveryDate(businessDeliveryDays) {
  // Get current time in Japan timezone (JST = UTC+9)
  const now = new Date();
  // Get UTC time and add 9 hours for Japan time
  const utcTime = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  const japanTime = new Date(utcTime.getTime() + 9 * 60 * 60 * 1000);
  const currentHour = japanTime.getHours();
  let baseDays = 1;

  if (currentHour < 12) {
    baseDays = 0; // Before 12 noon JST
  }

  // Use Japan date for calculation
  const today = new Date(
    japanTime.getFullYear(),
    japanTime.getMonth(),
    japanTime.getDate(),
  );

  // Add the base days to delivery days
  const totalDays = businessDeliveryDays + baseDays;
  const deliveryDate = new Date(today);

  // Get store holidays from window.storeHoliday
  const storeHolidays = window.storeHoliday
    ? window.storeHoliday.split(",")
    : [];

  // Function to check if a date is a holiday
  function isHoliday(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dateStr = `${year}-${month}-${day}`;
    return storeHolidays.includes(dateStr);
  }

  // Add total days (business days only - skip weekends and holidays)
  let addedDays = 0;
  while (addedDays < totalDays) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    // Skip weekends (Saturday = 6, Sunday = 0) and holidays
    // Note: If holiday falls on weekend, it's already skipped by weekend check
    const isWeekend =
      deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6;
    const isHolidayDay = isHoliday(deliveryDate);

    if (!isWeekend && !isHolidayDay) {
      addedDays++;
    }
  }

  // Get day of week in Japanese
  const dayNames = ["日", "月", "火", "水", "木", "金", "土"];
  const dayOfWeek = dayNames[deliveryDate.getDay()];

  // Calculate total days from today to deliveryDate (including weekends and holidays)
  const timeDiff = deliveryDate.getTime() - today.getTime();

  return {
    date: deliveryDate,
    dayOfWeek: dayOfWeek,
    totalDays: totalDays,
    formattedDate: `${
      deliveryDate.getMonth() + 1
    }/${deliveryDate.getDate()}(${dayOfWeek})`,
  };
}

// Global function for similar products navigation - Define early to ensure availability
window.scrollSimilarProducts = function (direction) {
  const swiperContainer = document.querySelector(".similar-products-swiper");

  if (swiperContainer && swiperContainer.swiper) {
    const swiper = swiperContainer.swiper;

    const beforeIndex = swiper.activeIndex;
    const beforeTranslate = swiper.translate;

    if (direction === "prev") {
      swiper.slidePrev();
    } else if (direction === "next") {
      swiper.slideNext();
    }

    // Check if anything changed after 100ms
    setTimeout(() => {
      // If activeIndex is NaN or no change detected, fix and try slideTo
      if (
        isNaN(swiper.activeIndex) ||
        (beforeIndex === swiper.activeIndex &&
          beforeTranslate === swiper.translate)
      ) {
        // Fix NaN activeIndex by setting to 0
        if (isNaN(swiper.activeIndex)) {
          swiper.activeIndex = 0;
          swiper.realIndex = 0;
        }

        if (direction === "next") {
          const nextIndex =
            swiper.activeIndex >= swiper.slides.length - 1
              ? 0
              : swiper.activeIndex + 1;
          swiper.slideTo(nextIndex);
        } else {
          const prevIndex =
            swiper.activeIndex <= 0
              ? swiper.slides.length - 1
              : swiper.activeIndex - 1;
          swiper.slideTo(prevIndex);
        }
      }
    }, 100);
  } else {
    // Try to initialize swiper if not ready
    if (swiperContainer) {
      try {
        swiperContainer.initialize();
        setTimeout(() => {
          if (swiperContainer.swiper) {
            if (direction === "prev") {
              swiperContainer.swiper.slidePrev();
            } else if (direction === "next") {
              swiperContainer.swiper.slideNext();
            }
          }
        }, 100);
      } catch (error) {}
    }
  }
};

// Global function for scrolling to order section
function scrollToOrderSection() {
  var orderSection = document.getElementById("order-section");
  if (!orderSection) return;

  // The header scroll handler (handlePcHeaderScroll) modifies
  // body.style.paddingTop during scroll, which interrupts smooth scrolling.
  // Fix: pre-apply the fixed header padding, then smooth scroll.
  var scrollContainer =
    document.body.scrollHeight > document.body.clientHeight
      ? document.body
      : document.documentElement;

  // Pre-apply fixed header state to prevent layout shift during scroll
  var headerMod = document.querySelector(".header_mod");
  if (headerMod && !headerMod.classList.contains("pc-fixed")) {
    var headerHeight = headerMod.offsetHeight;
    headerMod.classList.add("pc-fixed");
    document.body.style.paddingTop = headerHeight + "px";
  }

  // Calculate target position
  var headerOffset = headerMod ? headerMod.offsetHeight : 0;
  var elementPosition = orderSection.getBoundingClientRect().top;
  var currentScroll = scrollContainer.scrollTop;
  var targetPosition = currentScroll + elementPosition - headerOffset;

  // Smooth scroll using setInterval (more compatible than rAF for some environments)
  var startPosition = scrollContainer.scrollTop;
  var distance = targetPosition - startPosition;
  var duration = 500;
  var startTime = Date.now();

  var scrollInterval = setInterval(function () {
    var elapsed = Date.now() - startTime;
    var progress = Math.min(elapsed / duration, 1);
    // easeInOutCubic
    var eased =
      progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    scrollContainer.scrollTop = startPosition + distance * eased;

    if (progress >= 1) {
      clearInterval(scrollInterval);
    }
  }, 16);
}


// API call function
async function getProductsSimulatorAPI(filters = {}) {
  try {
    // Get default shape from current product metafield
    let defaultShape = [];
    if (
      window.PRODUCT_DATA &&
      window.PRODUCT_DATA.metafields &&
      window.PRODUCT_DATA.metafields.shape
    ) {
      defaultShape = [window.PRODUCT_DATA.metafields.shape];
    }

    // Create formData with proper structure
    const formData = {
      material: filters.material || [],
      shape: filters.shape || defaultShape,
      back: filters.back || [],
      type: filters.type || [],
      surface: filters.surface || [],
      excludeCollection: ["sample-products"],
      sortBy: filters.sortBy || "base_price",
      sortOrder: filters.sortOrder || "desc",
      cursor: filters.cursor || null,
      direction: filters.direction || null,
      pageSize: filters.limit,
    };

    const response = await fetch(FILTER_API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const result = await response.json();
      return { success: true, data: result };
    } else {
      let errorData = {};
      try {
        errorData = await response.json();
      } catch (e) {}

      const errorMessage =
        errorData.message ||
        `HTTP Error: ${response.status} ${response.statusText}`;
      return {
        success: false,
        error: errorMessage,
      };
    }
  } catch (error) {
    return {
      success: false,
      error: `Network error: ${error.message}`,
    };
  }
}

/**
 * 商品のサイズの表記（例: 57.0x57.0mm）。sections/product.liquid が #dynamic-price-range の data-size に入れる。
 * 縦・横のメタフィールドが無い商品では空文字を返す
 */
function getProductSizeLabel() {
  return document.getElementById("dynamic-price-range")?.dataset.size || "";
}

// Global functions for design modal
function openDesignModal(quantity, deliveryDay) {
  const modal = document.getElementById("designModal");
  if (modal) {
    // Store selected options
    modal.dataset.selectedQuantity = quantity;
    modal.dataset.selectedDeliveryDay = deliveryDay;

    // 何を選んだかをモーダルの上部に出す
    renderDesignModalSummary(quantity, deliveryDay);

    window.posthog?.capture?.("design_modal_open", {
      product_id: getProductHandleFromContext(),
      quantity: parseInt(quantity),
      delivery_days: parseInt(deliveryDay),
    });

    // Show modal
    modal.style.display = "flex";

    // Disable body scroll
    document.body.style.overflow = "hidden";

    // Add click outside to close（開くたびに登録が重ならないよう、1回だけ登録する）
    if (!modal.dataset.backdropHandlerAdded) {
      modal.dataset.backdropHandlerAdded = "true";
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          closeDesignModal();
        }
      });
    }
  }
}

/**
 * 注文モーダルに、商品のサイズと、選んだ包装・数量・納期・合計金額、出荷の目安を出す。
 * 金額は押した価格セルの表示（税込）をそのまま使い、値は textContent で入れる。
 * @param {string|number} quantity - 数量
 * @param {string|number} deliveryDay - 価格表の列の営業日（包装による加算は含まない）
 */
function renderDesignModalSummary(quantity, deliveryDay) {
  const summary = document.getElementById("designModalSummary");
  const summaryText = document.getElementById("designModalSummaryText");
  const shippingText = document.getElementById("designModalSummaryShipping");
  if (!summary || !summaryText) {
    return;
  }

  const baseDeliveryDays = parseInt(deliveryDay) || 0;
  const packagingOption = document.querySelector(".packaging-option.active");
  const packagingName = packagingOption?.dataset.packagingType || "";
  const packagingDeliveryDays =
    parseInt(packagingOption?.dataset.deliveryDays) || 0;
  const priceCell = document.querySelector(
    `.price-cell[data-quantity="${quantity}"][data-delivery-day="${deliveryDay}"]`,
  );
  const totalText = priceCell?.querySelector(".price-total em")?.textContent;

  const deliveryText =
    baseDeliveryDays > 0
      ? `${baseDeliveryDays}営業日` +
        (packagingDeliveryDays > 0 ? `（+${packagingDeliveryDays}営業日）` : "")
      : "";
  summaryText.textContent = [
    getProductSizeLabel(),
    packagingName,
    `${quantity}個`,
    deliveryText,
    totalText ? `合計 ${totalText}円（税込）` : "",
  ]
    .filter(Boolean)
    .join(" / ");

  if (shippingText) {
    if (baseDeliveryDays > 0) {
      const shippingDate = calculateDeliveryDate(
        baseDeliveryDays + packagingDeliveryDays,
      );
      shippingText.textContent = `出荷の目安：${shippingDate.formattedDate}`;
      shippingText.hidden = false;
    } else {
      shippingText.textContent = "";
      shippingText.hidden = true;
    }
  }

  summary.hidden = false;
}

function closeDesignModal() {
  const modal = document.getElementById("designModal");
  if (modal) {
    modal.style.display = "none";

    // Re-enable body scroll
    document.body.style.overflow = "auto";
  }
}

function openFileUpload() {
  const fileInput = document.getElementById("fileUpload");
  if (fileInput) {
    fileInput.click();
  }
}

function handleFileUpload(event) {
  const file = event.target.files[0];
  if (file) {
    // Validate file format
    if (!validateFileFormat(file)) {
      if (typeof showToast === "function") {
        showToast("ZIP形式のみサポートしています", "error");
      } else {
        alert("ZIP形式のみサポートしています");
      }
      event.target.value = ""; // Clear the input
      return;
    }

    // Show filename immediately
    showUploadProgress(file);

    // Show cart button immediately (no progress simulation delay)
    const btnAddToCart = document.getElementById("btnAddToCart");
    if (btnAddToCart) {
      btnAddToCart.disabled = false;
      btnAddToCart.style.opacity = "1";
      btnAddToCart.style.cursor = "pointer";
      if (!btnAddToCart.hasAttribute("data-handler-added")) {
        btnAddToCart.setAttribute("data-handler-added", "true");
      }
    }
    const cartContainer = document.getElementById("cartButtonContainer");
    if (cartContainer) {
      cartContainer.style.display = "flex";
    }

    // Hide error message when new file is selected
    const errorMsg = document.getElementById("cartErrorMessage");
    if (errorMsg) {
      errorMsg.style.display = "none";
    }
  }
}

function validateFileFormat(file) {
  const allowedExtensions = [".zip"];
  const fileName = file.name.toLowerCase();

  return allowedExtensions.some((ext) => fileName.endsWith(ext));
}

function showUploadProgress(file) {
  // Update legacy hidden elements for JS compatibility (keep hidden)
  const fileName = document.getElementById("fileName");
  if (fileName) {
    fileName.textContent = file.name;
  }

  // Show filename + delete button row
  const uploadedFileRow = document.getElementById("uploadedFileRow");
  const uploadedFileName = document.getElementById("uploadedFileName");
  if (uploadedFileName) {
    uploadedFileName.textContent = file.name;
  }
  if (uploadedFileRow) {
    uploadedFileRow.style.display = "flex";
  }
}

function simulateUploadProgress(file) {
  const fileSize = document.getElementById("fileSize");
  const fileStatus = document.getElementById("fileStatus");
  const progressBarFill = document.getElementById("progressBarFill");
  const btnAddToCart = document.getElementById("btnAddToCart");

  let progress = 0;
  const totalSize = file.size;
  const interval = setInterval(() => {
    progress += Math.random() * 15; // Random progress increment

    if (progress >= 100) {
      progress = 100;
      clearInterval(interval);

      // Upload completed
      if (fileStatus) {
        fileStatus.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#15AC28" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
          </svg>
          <span class="status-text">完了</span>
        `;
      }

      // Enable add to cart button
      if (btnAddToCart) {
        btnAddToCart.disabled = false;
        btnAddToCart.style.opacity = "1";
        btnAddToCart.style.cursor = "pointer";

        // Show cart button container
        const cartContainer = document.getElementById("cartButtonContainer");
        if (cartContainer) {
          cartContainer.style.display = "flex";
        }

        // Add click handler if not already added
        if (!btnAddToCart.hasAttribute("data-handler-added")) {
          btnAddToCart.setAttribute("data-handler-added", "true");
        }
      }
    } else {
      // Update progress
      if (fileStatus) {
        fileStatus.innerHTML = '<span class="status-text">読み込み中</span>';
      }
    }

    // Update progress bar
    if (progressBarFill) {
      progressBarFill.style.width = `${progress}%`;
    }

    // Update file size
    if (fileSize) {
      const uploadedSize = Math.floor((progress / 100) * totalSize);
      fileSize.textContent = `${formatFileSize(
        uploadedSize,
      )} / ${formatFileSize(totalSize)} •`;
    }
  }, 200);
}

function deleteUploadedFile() {
  // Cancel any in-progress upload
  if (typeof cancelFileUpload === "function") {
    cancelFileUpload();
  }

  const fileUploadProgress = document.getElementById("fileUploadProgress");
  const btnAddToCart = document.getElementById("btnAddToCart");
  const fileInput = document.getElementById("fileUpload");

  if (fileUploadProgress) {
    fileUploadProgress.style.display = "none";
  }

  // Disable add to cart button
  if (btnAddToCart) {
    btnAddToCart.disabled = true;
    btnAddToCart.style.opacity = "0.55";
    btnAddToCart.style.cursor = "not-allowed";
    btnAddToCart.removeAttribute("data-handler-added");
  }

  // Hide cart button container
  const cartContainer = document.getElementById("cartButtonContainer");
  if (cartContainer) {
    cartContainer.style.display = "none";
  }

  // Hide and clear the filename + delete row
  const uploadedFileRow = document.getElementById("uploadedFileRow");
  if (uploadedFileRow) {
    uploadedFileRow.style.display = "none";
  }
  const uploadedFileName = document.getElementById("uploadedFileName");
  if (uploadedFileName) {
    uploadedFileName.textContent = "";
  }

  // Reset progress bar
  const progressBar = document.getElementById("uploadProgressBar");
  const progressFill = document.getElementById("uploadProgressFill");
  const statusText = document.getElementById("uploadStatusText");
  if (progressBar) progressBar.style.display = "none";
  if (progressFill) {
    progressFill.style.width = "0%";
    progressFill.classList.remove("completed");
  }
  if (statusText) {
    statusText.style.display = "none";
    statusText.textContent = "";
    statusText.classList.remove("completed");
    statusText.style.color = "";
  }

  // Reset file input
  if (fileInput) {
    fileInput.value = "";
  }
}

function formatFileSize(bytes) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

function openSimulator() {
  const productHandle = saveCartDraft();
  if (productHandle) {
    // 直後に画面遷移するため、キューに溜めずにすぐ送る
    window.posthog?.capture?.(
      "cta_clicked",
      {
        cta_type: "simulator_open",
        source: "product_page",
        logged_in: true,
      },
      { send_instantly: true }
    );
    window.location.href = simulatorOverviewPath(productHandle);
  }
}

function openSimulatorLogin(loginUrl) {
  const productHandle = saveCartDraft();
  if (productHandle) {
    // 直後にログイン画面へ遷移するため、キューに溜めずにすぐ送る
    window.posthog?.capture?.(
      "simulator_gate_click",
      { product_id: productHandle },
      { send_instantly: true }
    );

    // ログイン URL にはクエリが付いている場合がある（新しい顧客アカウントなど）
    const url = new URL(loginUrl, window.location.origin);
    url.searchParams.set('return_to', simulatorOverviewPath(productHandle));
    window.location.href = url.href;
  }
}

// シミュレーター側で数量・納期の情報が見つからず商品ページへ戻されたとき（?sim_notice=need_options）に案内を出す
function showSimulatorNotice() {
  const url = new URL(window.location.href);
  if (url.searchParams.get("sim_notice") !== "need_options") {
    return;
  }

  if (typeof showToast === "function") {
    showToast(
      "デザインを作成する前に、価格表から数量と納期を選んで「注文する」を押してください。",
      "info",
      8000
    );
  }

  // 再読み込みや共有で同じ案内が出ないよう、URL から外す
  url.searchParams.delete("sim_notice");
  window.history.replaceState({}, "", url);
}

document.addEventListener("DOMContentLoaded", showSimulatorNotice);

function simulatorOverviewPath(productHandle) {
  return `/pages/overview-simulator?product_handle=${productHandle}`;
}

function saveCartDraft() {
  // Get product Handle from the current page using common.js function
  const productHandle = getProductHandleFromContext();

  // Get current selections using common.js functions
  const variantInfo = getSelectedVariantInfo();
  const modalSelection = getModalSelection();

  // Get pricePerUnit from selected table-cell
  const getPricePerUnitFromTable = () => {
    // Find the table-cell with 'selected' class
    const selectedTableCell = document.querySelector(
      ".table-cell.price-cell.selected",
    );
    if (selectedTableCell) {
      const pricePerUnitText =
        selectedTableCell.querySelector(".price-per-unit")?.textContent;
      if (pricePerUnitText) {
        // Extract number from text like "(¥1,144/個)"
        const match = pricePerUnitText.match(/¥([0-9,]+)/);
        return match ? match[1].replace(/,/g, "") : null;
      }
    }
    return null;
  };

  // Get total price (tax included) from selected table-cell, e.g. "1,050" -> "1050"
  const getSubtotalFromTable = () => {
    const totalText = document.querySelector(
      ".table-cell.price-cell.selected .price-total em",
    )?.textContent;
    return totalText ? totalText.replace(/,/g, "") : null;
  };

  // Create cartDraft object
  const cartDraft = {
    productHandle: productHandle,
    productName: window.PRODUCT_DATA?.title,
    variantId: variantInfo
      ? `gid://shopify/ProductVariant/${variantInfo.id}`
      : undefined,
    quantity: modalSelection ? parseInt(modalSelection.quantity) : undefined,
    deliveryDays: modalSelection
      ? parseInt(modalSelection.deliveryDay)
      : undefined,
    pricePerUnitDisplay: getPricePerUnitFromTable() || undefined,
    // デザイン確定ページの「ご注文内容」に出す値（価格表の金額は税込表示）
    subtotalDisplay: getSubtotalFromTable() || undefined,
    pricesIncludeTax: true,
    packagingName: variantInfo?.type || undefined,
    packagingDeliveryDays: parseInt(variantInfo?.deliveryDays) || 0,
  };

  // Save to localStorage
  try {
    localStorage.setItem("cartDraft", JSON.stringify(cartDraft));
  } catch (error) {
    // Failed to save cart draft to localStorage
  }

  return productHandle;
}

// Helper function to get product Handle
function getProductHandle() {
  // Get product Handle from URL path: /products/iphone-16 -> iphone-16
  const pathSegments = window.location.pathname.split("/");
  const productsIndex = pathSegments.indexOf("products");

  if (productsIndex !== -1 && productsIndex + 1 < pathSegments.length) {
    const productHandle = pathSegments[productsIndex + 1];
    if (productHandle && productHandle !== "") {
      return productHandle;
    }
  }

  // Fallback: try to get from URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const productHandle =
    urlParams.get("handle") || urlParams.get("product_handle");

  if (productHandle) {
    return productHandle;
  }

  // Try to get from meta tag
  const metaProductHandle = document.querySelector(
    'meta[name="product_handle"]',
  );
  if (metaProductHandle) {
    return metaProductHandle.getAttribute("content");
  }

  // Try to get from data attribute on body or main container
  const bodyProductHandle = document.body.getAttribute("data-product-handle");
  if (bodyProductHandle) {
    return bodyProductHandle;
  }

  // Try to get from product form or other elements
  const productForm = document.querySelector("form[data-product-handle]");
  if (productForm) {
    return productForm.getAttribute("data-product-handle");
  }

  return null;
}

// Product Detail JavaScript
document.addEventListener("DOMContentLoaded", function () {
  // Track selected variant
  let selectedVariantId = null;
  let selectedVariantHandle = null;

  setTimeout(function () {
    reorganizeJudgeMeStructure();
  }, 300);

  // Initialize with first variant (active by default)
  const firstOption = document.querySelector(".packaging-option.active");
  if (firstOption) {
    selectedVariantId = firstOption.dataset.variantId;
    selectedVariantHandle = firstOption.dataset.variantHandle;
  }

  // Add click handlers to packaging options
  document.querySelectorAll(".packaging-option").forEach((option) => {
    option.addEventListener("click", function () {
      // Remove active class from all options
      document
        .querySelectorAll(".packaging-option")
        .forEach((opt) => opt.classList.remove("active"));

      // Add active class to clicked option
      this.classList.add("active");

      // Update selected variant
      selectedVariantId = this.dataset.variantId;
      selectedVariantHandle = this.dataset.variantHandle;
      // Re-render price matrix with new variant price
      if (window.ProductDetail && window.ProductDetail.reRenderMatrix) {
        window.ProductDetail.reRenderMatrix();
      }
    });
  });
});

// Export functions for external use
window.ProductDetail = {
  getSelectedVariant: function () {
    const selectedOption = document.querySelector(".packaging-option.active");
    if (selectedOption) {
      return {
        id: selectedOption.dataset.variantId,
        handle: selectedOption.dataset.variantHandle,
        price: selectedOption.dataset.price,
        type: selectedOption.dataset.packagingType,
        // saveCartDraft が包装の加算日数（packagingDeliveryDays）に使う。script.common.js のフォールバックと形をそろえる
        deliveryDays: selectedOption.dataset.deliveryDays,
      };
    }
    return null;
  },

  onVariantChange: function (callback) {
    document.querySelectorAll(".packaging-option").forEach((option) => {
      option.addEventListener("click", function () {
        const variantData = {
          id: this.dataset.variantId,
          handle: this.dataset.variantHandle,
          price: this.dataset.price,
          type: this.dataset.packagingType,
        };
        callback(variantData);
      });
    });
  },
};

// Product Detail JavaScript - Matrix Render API Integration + Scroll Navigation
document.addEventListener("DOMContentLoaded", async function () {
  // Global variables for thumbnail navigation
  let currentThumbnailIndex = 0;
  let visibleThumbnails = 4; // Number of thumbnails visible at once
  // Initialize product image slider when DOM is loaded
  setTimeout(() => {
    if (
      window.ProductDetail &&
      window.ProductDetail.initializeProductImageSlider
    ) {
      window.ProductDetail.initializeProductImageSlider();
    } else {
      // ProductDetail not found or initializeProductImageSlider not available
    }
  }, 200);

  initializeProductImageSlider();
  // Load similar products
  setTimeout(async () => {
    try {
      // Test if function exists
      if (typeof getProductsSimulatorAPI !== "function") {
        // Hide section
        const similarProductsSection = document.querySelector(
          ".similar-products-section",
        );
        if (similarProductsSection) {
          similarProductsSection.style.display = "none";
        }
        return;
      }

      const result = await getProductsSimulatorAPI({ limit: 10 }); // Increase to ensure enough slides for loop

      if (result.success && result.data && result.data.products) {
        renderSimilarProducts(result.data.products);
      } else {
        // Hide section if no products
        const similarProductsSection = document.querySelector(
          ".similar-products-section",
        );
        if (similarProductsSection) {
          similarProductsSection.style.display = "none";
        }
      }
    } catch (error) {
      // Hide section on error
      const similarProductsSection = document.querySelector(
        ".similar-products-section",
      );
      if (similarProductsSection) {
        similarProductsSection.style.display = "none";
      }
    }
  }, 1000); // Increased timeout to 1 second

  // Global state
  let matrixData = null;
  let selectedQuantityRange = null;
  let selectedPackaging = null;

  // Initialize
  await loadMatrixOptions();

  // Load matrix options from API
  async function loadMatrixOptions() {
    try {
      const productHandle = getProductHandle();
      const response = await fetch(
        `${window.apiUrl}/api/matrix-options?product_handle=${productHandle}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        matrixData = result.data;
        ("マトリックスデータを読み込みました:", matrixData);

        // Update product price with cheapest price from matrix
        updateProductDetail();

        // Render Step 1 and Step 3 (Step 2 keep using variants)
        renderStep1QuantityOptions();

        // Set default selections (use first option from sorted list)
        if (matrixData.step1Options.length > 0) {
          const sortedOptions = [...matrixData.step1Options].sort(
            (a, b) => a.start - b.start,
          );
          selectQuantityRange(sortedOptions[0]);
        }

        // Render initial price matrix
        renderStep3PriceMatrix();
      } else {
        showError("価格オプションの読み込みに失敗しました");
        hidePendingProductDetail();
      }
    } catch (error) {
      showError(
        "価格オプションの読み込みに失敗しました。もう一度お試しください。",
      );
      hidePendingProductDetail();
    }
  }

  // Render Step 1: Quantity Options
  function renderStep1QuantityOptions() {
    const container = document.getElementById("step1-quantity-options");
    if (!container || !matrixData.step1Options) return;

    // Sort options by start quantity (smallest to largest)
    const sortedOptions = [...matrixData.step1Options].sort(
      (a, b) => a.start - b.start,
    );

    const optionsHTML = sortedOptions
      .map(
        (option, index) => `
      <div class="quantity-option ${index === 0 ? "active" : ""}" 
           data-range-index="${index}"
           data-start="${option.start}"
           data-end="${option.end}"
           data-step-interval="${option.step_interval}">
        <div class="radio-button">
          <div class="radio-outer">
            <div class="radio-inner"></div>
          </div>
        </div>
        <span>${option.start}～${option.end}個</span>
      </div>
    `,
      )
      .join("");

    container.innerHTML = optionsHTML;

    // Add click handlers
    addQuantityOptionHandlers();
  }

  // Render Step 3: Price Matrix
  function renderStep3PriceMatrix() {
    const container = document.getElementById("step3-quantity-table-loading");
    if (!container || !selectedQuantityRange) return;

    const matrix = generatePriceMatrix();
    const tableHTML = generatePriceTableHTML(matrix);

    // Clear container and add new content
    container.innerHTML = tableHTML;

    // Add click handlers for price cells
    addPriceCellHandlers();
  }

  // Generate price matrix based on selections
  function generatePriceMatrix() {
    if (!selectedQuantityRange || !matrixData.rates) return [];

    const matrix = [];
    const { start, end, step_interval } = selectedQuantityRange;

    for (let quantity = start; quantity <= end; quantity += step_interval) {
      try {
        // Calculate price for each delivery day
        const prices = {};
        selectedQuantityRange.deliveryDays.forEach((deliveryDay) => {
          // Calculate price: basePrice + (quantity * rate) + deliveryDay.rate
          const price = calculatePrice(quantity, deliveryDay.rate);
          prices[deliveryDay.delivery_day] = price;
        });

        matrix.push({
          quantity,
          prices,
          available: true,
        });
      } catch (error) {
        matrix.push({
          quantity,
          prices: {},
          available: false,
          error: error.message,
        });
      }
    }

    return matrix;
  }

  // Helper function to calculate price for specific quantity and delivery day
  function calculatePrice(quantity, deliveryRate) {
    if (!matrixData.rates) return 0;

    const basePrice = matrixData.rates.basePrice || 0;

    // Find quantity break rate
    const quantityBreakRate = findQuantityBreakRate(quantity);
    const rate = quantityBreakRate || 0;

    // Get selected variant price (addon price)
    const variantPrice = getSelectedVariantPrice();

    // Calculate according to the formula from product-preview.md:
    // FINAL_PRICE = [base_price] × [rate] × [delivery_modifier_n] × [quantity]
    //              + ([addon_price_1] + [addon_price_2] + ... + [addon_price_n]) × quantity
    // Based on backend code, rates are percentages and need to be divided by 100
    const rateDecimal = rate / 100;
    const deliveryRateDecimal = deliveryRate / 100;

    // Main calculation: base_price × (rate/100) × (delivery_rate/100) × quantity
    const basePriceComponent =
      Math.round(basePrice * rateDecimal * deliveryRateDecimal) * quantity;

    // Addon calculation: addon_price × quantity (addon is NOT affected by rate/delivery rate)
    const addonComponent = variantPrice * quantity;

    // Final price
    const totalPrice = basePriceComponent + addonComponent;
    return Math.round(totalPrice);
  }

  // Helper function to get selected variant price
  function getSelectedVariantPrice() {
    const selectedOption = document.querySelector(".packaging-option.active");
    if (selectedOption) {
      // Handle price with currency symbol like "¥1,000" (comma is thousands separator)
      const priceStr = selectedOption.dataset.price || "0";
      // Remove currency symbols and parse the number
      const cleanPrice = priceStr.replace(/[^\d.,]/g, "");
      // In Japanese Yen format, comma is thousands separator, so "1,000" = 1000
      const price = parseFloat(cleanPrice.replace(/,/g, "")) || 0;
      return price;
    }
    return 0;
  }

  // Helper function to find quantity break rate
  function findQuantityBreakRate(quantity) {
    if (!matrixData.rates || !matrixData.rates.quantityBreakRates) return 0;

    const quantityBreakRates = matrixData.rates.quantityBreakRates;

    for (const breakRate of quantityBreakRates) {
      if (quantity >= breakRate.start && quantity <= breakRate.end) {
        return breakRate.rate;
      }
    }

    return 0;
  }

  // Get delivery days from selected variant in step 2
  function getDeliveryDaysFromVariant() {
    // Get the currently selected packaging variant
    const selectedPackaging = document.querySelector(
      ".packaging-option.active",
    );
    if (!selectedPackaging) {
      return 0;
    }

    // Get delivery_days from data attribute
    const deliveryDays = selectedPackaging.getAttribute("data-delivery-days");
    return deliveryDays ? parseInt(deliveryDays) : 0;
  }

  /**
   * 価格の見出しに出す、最安の1個あたりの価格と、その価格になる条件を API のデータから求める。
   * price / quantity / quantityEnd / deliveryDay: 価格表でいちばん安いセルの1個あたりの価格と、その数量・納期（営業日）
   *   （getCheapestPriceCell。包装は追加料金がいちばん安いもの）
   * deliveryDays: すべての数量の納期の最短と最長（最短の出荷日に使う）
   * 数量の掛け率と納期の掛け率を別々に最小にすると、その2つが同じセルに無い設定では、
   * 価格表のどのセルでも注文できない価格になる。だから価格表のセルから求める
   */
  function getInforProductDetail(apiData) {
    // rates や step1Options が無い応答で TypeError にならないよう、使う前に確かめる
    if (!apiData?.rates || !apiData.step1Options?.length) return null;
    if (
      !apiData.rates.quantityBreakRates?.length ||
      !apiData.step2Options?.length
    ) {
      return null;
    }
    const minSurcharge = Math.min(
      ...apiData.step2Options.map((option) => option.surcharge),
    );
    const allDeliveryDays = apiData.step1Options.flatMap((option) =>
      (option?.deliveryDays || []).map((dd) => dd.delivery_day),
    );
    const minDeliveryDays = Math.min(...allDeliveryDays);
    const maxDeliveryDays = Math.max(...allDeliveryDays);
    const cheapestCell = getCheapestPriceCell(apiData, minSurcharge);

    // 価格のあるセルが無い・納期が無い応答では、出せる値が無いので null を返す
    if (!cheapestCell || !Number.isFinite(minDeliveryDays)) return null;
    return {
      ...cheapestCell,
      deliveryDays: { min: minDeliveryDays, max: maxDeliveryDays },
    };
  }

  /**
   * 数量の掛け率（findQuantityBreakRate と同じく、数量を含む最初の区分の掛け率）。
   * どの区分にも入らない数量では null を返す
   */
  function getQuantityBreakRateOf(quantityBreakRates, quantity) {
    const breakRate = quantityBreakRates.find(
      (rate) => quantity >= rate.start && quantity <= rate.end,
    );
    return breakRate ? Number(breakRate.rate) : null;
  }

  /**
   * 価格表の1つのセルの1個あたりの価格。calculatePrice と generatePriceTableHTML と同じ丸め方にする
   * （掛け率をかけた基本価格を円に丸めて数量をかけ、追加料金を足した総額を丸め、数量で割って丸める）
   */
  function getPriceCellUnitPrice(
    basePrice,
    quantityBreakRate,
    deliveryRate,
    surcharge,
    quantity,
  ) {
    const total = Math.round(
      Math.round(
        basePrice * (quantityBreakRate / 100) * (deliveryRate / 100),
      ) *
        quantity +
        surcharge * quantity,
    );
    return Math.round(total / quantity);
  }

  /**
   * 価格表のいちばん安いセル（価格・数量・納期）を返す。同じ価格なら、少ない数量・短い納期のセルにする。
   * セルは generatePriceMatrix と同じく、数量の選択肢ごとに start から step_interval きざみの行と、その選択肢の納期の列。
   * 数量の範囲は 1～999999・きざみ 1 まで登録できるので、行の配列は作らずに1行ずつ見る。
   * quantityEnd は、同じ選択肢・同じ納期のまま同じ価格が続く最後の数量（getPriceRunEnd）。
   * 価格のあるセルが無ければ null を返す
   */
  function getCheapestPriceCell(apiData, surcharge) {
    const { basePrice, quantityBreakRates } = apiData.rates;
    const unitPriceAt = (quantity, deliveryRate) => {
      const breakRate = getQuantityBreakRateOf(quantityBreakRates, quantity);
      // どの区分にも入らない数量は、価格表では掛け率 0 の価格になる。見出しには使わない
      if (breakRate === null) return NaN;
      return getPriceCellUnitPrice(
        basePrice,
        breakRate,
        deliveryRate,
        surcharge,
        quantity,
      );
    };
    let cheapest = null;
    for (const option of apiData.step1Options) {
      const step = Number(option?.step_interval);
      // きざみが 0 や数値でないと終わらないので、その選択肢は使わない
      if (!(step > 0) || !option.deliveryDays?.length) continue;
      // 価格表と同じく、同じ納期が2つあれば後のほうの掛け率になる
      const deliveryRates = new Map(
        option.deliveryDays.map((dd) => [
          Number(dd.delivery_day),
          Number(dd.rate),
        ]),
      );
      const end = Number(option.end);
      for (
        let quantity = Number(option.start);
        quantity <= end;
        quantity += step
      ) {
        for (const [deliveryDay, deliveryRate] of deliveryRates) {
          const price = unitPriceAt(quantity, deliveryRate);
          // 価格が 0 以下や数値でないセルは、価格表では「-」になる
          if (!Number.isFinite(price) || price <= 0) continue;
          if (
            cheapest &&
            !isCheaperPriceCell(price, quantity, deliveryDay, cheapest)
          ) {
            continue;
          }
          cheapest = { price, quantity, deliveryDay, deliveryRate, step, end };
        }
      }
    }
    if (!cheapest) return null;
    return {
      price: cheapest.price,
      quantity: cheapest.quantity,
      quantityEnd: getPriceRunEnd(cheapest, unitPriceAt),
      deliveryDay: cheapest.deliveryDay,
    };
  }

  // 価格表のセル（price・quantity・deliveryDay）が cell より見出しに向くか。安い順、同じ価格なら少ない数量・短い納期の順
  function isCheaperPriceCell(price, quantity, deliveryDay, cell) {
    if (price !== cell.price) return price < cell.price;
    if (quantity !== cell.quantity) return quantity < cell.quantity;
    return deliveryDay < cell.deliveryDay;
  }

  /**
   * cell と同じ選択肢・同じ納期のまま、同じ1個あたりの価格が続く最後の数量。
   * 選択肢の最後の行まで続くときも、その行の数量にする
   * （価格表より多い数量はこの価格表では選べないので、見出しに「以上」とは書かない）
   */
  function getPriceRunEnd(cell, unitPriceAt) {
    let quantityEnd = cell.quantity;
    for (
      let quantity = cell.quantity + cell.step;
      quantity <= cell.end;
      quantity += cell.step
    ) {
      if (unitPriceAt(quantity, cell.deliveryRate) !== cell.price) break;
      quantityEnd = quantity;
    }
    return quantityEnd;
  }

  /**
   * 価格の見出しの横に出す条件（例:（1,000～5,000個・15営業日の場合の1個あたり / 57.0x57.0mm））。
   * 数量や納期が数値でなければ、その条件は出さない
   */
  function formatPriceCondition(infoProductDetail, size) {
    const { quantity, quantityEnd, deliveryDay } = infoProductDetail;
    const conditions = [];
    if (Number.isFinite(quantity)) {
      // 範囲が無い（その数量の行だけがこの価格になる）ときは、その数量だけを出す
      conditions.push(
        Number.isFinite(quantityEnd) && quantityEnd > quantity
          ? `${quantity.toLocaleString()}～${quantityEnd.toLocaleString()}個`
          : `${quantity.toLocaleString()}個`,
      );
    }
    if (Number.isFinite(deliveryDay)) {
      conditions.push(`${deliveryDay}営業日`);
    }
    const condition =
      conditions.length > 0
        ? `${conditions.join("・")}の場合の1個あたり`
        : "1個あたり";
    return `（${condition}${size ? ` / ${size}` : ""}）`;
  }

  // 価格 API の応答待ちで見せていない要素（is-pending）を隠す。応答が使えなかったときに呼ぶ。
  // 中身を入れて見せた要素はそのままにする
  function hidePendingProductDetail() {
    document
      .querySelectorAll(
        ".product-price-section.is-pending, .shipping-info.is-pending",
      )
      .forEach((element) => {
        element.hidden = true;
      });
  }

  // Update product price with cheapest price from API data
  function updateProductDetail() {
    const infoProductDetail = getInforProductDetail(matrixData);
    // 価格を出せない応答のときは、空の「円～」や差し込む前の文言を残さず隠す。
    // （以前は null のまま deliveryDays を読んで TypeError になり、価格表までエラー表示になっていた）
    if (!infoProductDetail || !infoProductDetail.price) {
      hidePendingProductDetail();
      return;
    }

    const resultDeliverDays = calculateDeliveryDate(
      infoProductDetail.deliveryDays.min,
    );
    const priceSection = document.querySelector(".product-price-section");
    const priceElement = document.getElementById("dynamic-price");
    const priceRangeElement = document.getElementById("dynamic-price-range");
    const shippingInfoElement = document.querySelector(".shipping-info");
    const shippingTitleElement = document.getElementById(
      "dynamic-shipping-title",
    );
    const dynamicShippingNote2Element = document.getElementById(
      "dynamic-shipping-note-2",
    );
    if (priceElement) {
      priceElement.textContent = `${Math.round(
        infoProductDetail.price,
      ).toLocaleString()}`;
    }
    if (priceRangeElement) {
      // 「円～」がどの数量・納期の1個あたりの価格かを出す
      priceRangeElement.textContent = formatPriceCondition(
        infoProductDetail,
        getProductSizeLabel(),
      );
    }
    if (shippingTitleElement) {
      shippingTitleElement.textContent = `最短${resultDeliverDays.formattedDate}出荷可能`;
    }
    if (dynamicShippingNote2Element) {
      // sections/product.liquid が data-template に入れた文言の %DELIVERY_DAYS% を、最短の日数に置き換える
      const template = dynamicShippingNote2Element.dataset.template || "";
      dynamicShippingNote2Element.textContent = template.replace(
        "%DELIVERY_DAYS%",
        infoProductDetail.deliveryDays.min,
      );
    }
    priceSection?.classList.remove("is-pending");
    shippingInfoElement?.classList.remove("is-pending");
  }

  // Generate HTML for price table
  function generatePriceTableHTML(matrix) {
    if (!matrix.length)
      return '<div class="no-data">価格データがありません</div>';
    const deliveryDays = getDeliveryDaysFromVariant();

    // Create header row
    // 納期が長い（単価が安い）列を左端に置く。スマホで最安の列が画面外に出ないようにするため
    const sortedDeliveryDays = [...selectedQuantityRange.deliveryDays].sort(
      (a, b) => b.delivery_day - a.delivery_day,
    );
    const headerCells = `
      <div class="header-cell">個数</div>
      ${sortedDeliveryDays
        .map((dd) => {
          // Get delivery days from variant metafield
          if (deliveryDays && deliveryDays > 0) {
            ("deliveryDays", deliveryDays);
            return `<div class="header-cell">${dd.delivery_day}営業日 (+${deliveryDays}営業日)</div>`;
          } else {
            return `<div class="header-cell">${dd.delivery_day}営業日</div>`;
          }
        })
        .join("")}
    `;
    // Create data rows
    const dataRows = matrix
      .map(
        (item) => `
      <div class="table-row">
        <div class="table-cell">${item.quantity}</div>
        ${sortedDeliveryDays
          .map((dd) => {
            try {
              const price = item.prices[dd.delivery_day];
              if (price && item.available) {
                const pricePerUnit = Math.round(price / item.quantity);
                return `<div class="table-cell price-cell" data-quantity="${
                  item.quantity
                }" data-delivery-day="${
                  dd.delivery_day
                }" onclick="openDesignModal('${item.quantity}', '${
                  dd.delivery_day
                }')">
            <div class="price-cell-price">
              <div class="price-total"><em>${Math.round(
                pricePerUnit * item.quantity,
              ).toLocaleString()}</em>円</div>
              <div class="price-per-unit">(¥${pricePerUnit.toLocaleString()}/個)</div>
            </div>
            <div class="price-cell-button">注文する</div>
          </div>`;
              } else {
                return `<div class="table-cell unavailable">-</div>`;
              }
            } catch (error) {
              return `<div class="table-cell unavailable">-</div>`;
            }
          })
          .join("")}
      </div>
    `,
      )
      .join("");

    const emptyRow = `
    <div class="table-row" style="height: 20px; border: none;">
      <div class="table-cell" style="border: none; height: 20px;"></div>
      ${sortedDeliveryDays
        .map(
          () =>
            `<div class="table-cell" style="border: none; height: 20px;"></div>`,
        )
        .join("")}
    </div>
    `;

    // Return complete table structure matching CSS expectations
    return `
      <div class="table-container">
        <div class="table-header">
          ${headerCells}
        </div>
        <div class="table-rows">
          ${dataRows}
          ${emptyRow}          
        </div>
      </div>
    `;
  }

  // Event Handlers
  function addQuantityOptionHandlers() {
    document.querySelectorAll(".quantity-option").forEach((option) => {
      option.addEventListener("click", function () {
        // Remove active class from all options
        document
          .querySelectorAll(".quantity-option")
          .forEach((opt) => opt.classList.remove("active"));

        // Add active class to clicked option
        this.classList.add("active");

        // Update selection
        const rangeIndex = parseInt(this.dataset.rangeIndex);
        selectQuantityRange(matrixData.step1Options[rangeIndex]);
      });
    });
  }

  function addPriceCellHandlers() {
    document.querySelectorAll(".price-cell").forEach((cell) => {
      // Click handler
      cell.addEventListener("click", function () {
        const quantity = parseInt(this.dataset.quantity);
        const deliveryDay = parseInt(this.dataset.deliveryDay);

        // Update selected quantity and delivery day
        updateSelection(quantity, deliveryDay);

        // Highlight selected cell
        document
          .querySelectorAll(".price-cell")
          .forEach((c) => c.classList.remove("selected"));
        this.classList.add("selected");
      });

      // Touch device support
      cell.addEventListener("touchstart", function () {
        this.style.transform = "translateY(-1px) scale(1.01)";
      });

      cell.addEventListener("touchend", function () {
        this.style.transform = "";
      });
    });
  }

  // Selection Management
  function selectQuantityRange(quantityRange) {
    selectedQuantityRange = quantityRange;

    // Re-render price matrix
    renderStep3PriceMatrix();
  }

  function updateSelection(quantity, deliveryDay) {
    ("選択が更新されました:", { quantity, deliveryDay });
    // You can add additional logic here
    // For example, update cart, show order summary, etc.
  }

  // Utility Functions
  function showError(message) {
    const containers = ["step1-quantity-options", "step3-quantity-table"];

    containers.forEach((id) => {
      const container = document.getElementById(id);
      if (container) {
        container.innerHTML = `<div class="error">${message}</div>`;
      }
    });
  }

  // ===== THUMBNAIL NAVIGATION =====
  // Function to scroll thumbnails
  function scrollThumbnails(direction) {
    const container = document.getElementById("thumbnailsContainer");
    const thumbnailItems = document.querySelectorAll(".thumbnail-item");
    const totalThumbnails = thumbnailItems.length;

    if (direction === "next") {
      if (currentThumbnailIndex + visibleThumbnails < totalThumbnails) {
        currentThumbnailIndex++;
      }
    } else if (direction === "prev") {
      if (currentThumbnailIndex > 0) {
        currentThumbnailIndex--;
      }
    }

    // Update button states
    updateNavButtons();

    // Scroll to show the current set of thumbnails
    const thumbnailWidth = 80 + 8; // width + gap
    const scrollPosition = currentThumbnailIndex * thumbnailWidth;
    container.scrollTo({
      left: scrollPosition,
      behavior: "smooth",
    });
  }

  // Function to update navigation button states
  function updateNavButtons() {
    const prevBtn = document.querySelector(".prev-btn");
    const nextBtn = document.querySelector(".next-btn");
    const thumbnailItems = document.querySelectorAll(".thumbnail-item");
    const totalThumbnails = thumbnailItems.length;

    // Disable prev button if at the beginning
    if (currentThumbnailIndex <= 0) {
      prevBtn.disabled = true;
    } else {
      prevBtn.disabled = false;
    }

    // Disable next button if at the end
    if (currentThumbnailIndex + visibleThumbnails >= totalThumbnails) {
      nextBtn.disabled = true;
    } else {
      nextBtn.disabled = false;
    }
  }

  // Function to update active thumbnail
  function updateThumbnailActive(activeIndex) {
    const thumbnailItems = document.querySelectorAll(".thumbnail-item");
    thumbnailItems.forEach((item, index) => {
      if (index === activeIndex) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }

  // 類似商品の画像は原寸で返ってくるので、Shopify CDN の画像だけカード幅（最大 200px）の2倍に縮めて読む
  function toSimilarProductImageUrl(imageUrl) {
    if (!imageUrl) return "";
    try {
      const url = new URL(imageUrl, window.location.origin);
      if (url.hostname.endsWith("shopify.com") || url.pathname.includes("/cdn/shop/")) {
        url.searchParams.set("width", "400");
        return url.toString();
      }
    } catch (error) {
      // URL として読めないときは元の値のまま使う
    }
    return imageUrl;
  }

  // Function to render similar products
  function renderSimilarProducts(response) {
    const swiperContainer = document.querySelector(".similar-products-swiper");
    const similarProductsSection = document.querySelector(
      ".similar-products-section",
    );

    if (!swiperContainer) {
      return;
    }

    // Handle both direct array and response object formats
    const products = response.products || response;

    if (!products || products.length === 0) {
      ("ℹ️ No similar products to render, hiding section");
      if (similarProductsSection) {
        similarProductsSection.style.display = "none";
      }
      return;
    }

    // Filter out current product from similar products
    const currentProductId = String(window.PRODUCT_DATA?.id);
    const filteredProducts = products.filter((product) => {
      const productData = product.node || product;
      const productId = normalizeProductId(productData.id);
      ("🔍 製品ID: ", productId, "現在の製品ID: ", currentProductId);
      return productId !== currentProductId;
    });

    if (filteredProducts.length === 0) {
      ("ℹ️ No similar products after filtering current product, hiding section");
      if (similarProductsSection) {
        similarProductsSection.style.display = "none";
      }
      return;
    }

    // Determine how many products to display and whether to show navigation
    const hasEnoughProducts = filteredProducts.length >= 5;

    // Use filtered products (excluding current product)
    let displayProducts = [...filteredProducts]; // Start with filtered products

    const hasEnoughForLoop = displayProducts.length >= 6; // Need at least 6 slides for loop mode

    const productsHTML = displayProducts
      .map((product, index) => {
        // Handle the response structure: product.node contains the actual product data
        const productData = product.node || product;
        const imageUrl = toSimilarProductImageUrl(productData.image || "");
        const price = parseFloat(productData.minPrice) || 0;
        const handle = productData.handle || "";
        const title = productData.title || "商品";
        const productId = normalizeProductId(productData.id);

        return `
      <swiper-slide>
        <div class="col product-card" data-product-handle="${handle}" data-product-id="${productId}">
          <div class="slide-item h-100">
            <div class="product-item h-100" data-product-handle="${handle}" data-product-id="${productId}">
              <div class="card h-100 position-relative">
                <a href="/products/${handle}" class="card-link text-decoration-none">
                  <img src="${imageUrl}" alt="${title}" class="product-img" width="" height="" loading="lazy" decoding="async">
                  <div class="card-body">
                    <div class="product-info text-center">
                      <div class="product-name">${title}</div>
                      <div class="product-price">
                        <span class="price-symbol">1点(税込)</span>
                        <span class="price-amount num">${price}</span>
                        <span class="price-unit">円〜</span>
                      </div>
                    </div>
                  </div>
                </a>
                <button class="favorite-btn position-absolute top-2 end-2" data-product-id="${productId}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-heart　cls-1"
                        viewBox="0 0 25.02 20.1">
                        <defs>
                            <style>
                                .cls-1 {
                                    fill: #d3d3d3;
                                }
                            </style>
                        </defs>
                        <g id="main">
                            <path class="cls-1"
                                d="M13.65,19.73c-.68.49-1.59.49-2.27,0l-2.68-1.93c-.07-.05-1.74-1.26-3.43-2.72-1.11-.96-2-1.82-2.71-2.62-.63-.72-2.56-2.91-2.56-5.94C0,2.92,2.92,0,6.52,0c2.69,0,4.99,1.62,5.99,3.94,1-2.32,3.31-3.94,5.99-3.94,3.6,0,6.52,2.92,6.52,6.52,0,3.03-1.92,5.22-2.56,5.94-.71.8-1.59,1.66-2.71,2.62-1.69,1.45-3.36,2.66-3.43,2.72l-2.68,1.93Z" />
                        </g>
                    </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    `;
      })
      .join("");

    // Show section only if we have products to display
    if (similarProductsSection) {
      ("🔍 Display products length:", displayProducts);
      if (displayProducts.length > 0) {
        similarProductsSection.style.display = "flex"; // Use flex instead of block to maintain layout
      } else {
        similarProductsSection.style.display = "none";
      }
    }

    swiperContainer.innerHTML = productsHTML;

    // Update swiper configuration based on product count
    if (swiperContainer.swiper) {
      // Update existing swiper
      swiperContainer.swiper.params.loop = hasEnoughForLoop; // Enable loop only for 6+ products
      swiperContainer.swiper.params.slidesPerView = "auto"; // Auto width based on CSS
      swiperContainer.swiper.update();
    } else {
      // Set attributes for new swiper initialization
      swiperContainer.setAttribute("loop", hasEnoughForLoop ? "true" : "false");
      swiperContainer.setAttribute("slides-per-view", "auto"); // Auto width based on CSS

      // Force swiper to reinitialize
      setTimeout(() => {
        if (swiperContainer.swiper) {
          swiperContainer.swiper.update();
        }
      }, 100);
    }

    // Show/hide navigation buttons based on product count
    const navigationDiv = document.querySelector(
      ".similar-products-navigation",
    );
    if (navigationDiv) {
      if (hasEnoughProducts) {
        navigationDiv.style.display = "flex";
      } else {
        navigationDiv.style.display = "none";
      }
    }

    swiperContainer.querySelectorAll(".product-card").forEach((card) => {
      // Remove any existing click handlers
      card.onclick = null;
    });

    // Set initial favorite state and add handlers for similar products
    const cachedIds = new Set(loadFavouriteIds().map(String));

    swiperContainer.querySelectorAll(".favorite-btn").forEach((btn) => {
      const productCard = btn.closest(".product-card");
      const productId = normalizeProductId(
        productCard.getAttribute("data-product-id"),
      );

      // Set initial favorite state from cache
      if (productId && cachedIds.has(productId)) {
        btn.classList.add("favourite-active");
      }

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const productHandle = productCard.getAttribute("data-product-handle");
        const numericProductId = normalizeProductId(productId);

        if (!productHandle || !productId) {
          return;
        }

        // Get access token
        const customerAccessToken = JSON.parse(
          localStorage.getItem(window.customerAccessTokenKey),
        );
        const accessToken = customerAccessToken
          ? customerAccessToken.accessToken
          : null;

        if (!accessToken) {
          // User not logged in - show login modal
          const loginModal = new bootstrap.Modal(
            document.getElementById("confirmLoginModal"),
          );
          loginModal.show();
          return;
        }

        // Disable button to prevent spam clicks
        this.disabled = true;

        // Toggle visual state immediately
        this.classList.toggle("favourite-active");

        // Use actual 製品ID for API call
        const apiProductId = productId;

        // Call API to toggle favorite
        // トークンは Authorization ヘッダーでも送る。今のバックエンドは body の accessToken を読むので、body からはまだ外さない
        fetch(FAVOURITES_API_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          mode: "cors",
          body: JSON.stringify({
            accessToken,
            productId: apiProductId,
          }),
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.success) {
              // Update localStorage cache based on API response
              const ids = new Set(loadFavouriteIds().map(normalizeProductId));

              if (result.data.action === "added") {
                ids.add(normalizeProductId(numericProductId));
                ("商品をお気に入りに追加しました");
              } else {
                ids.delete(normalizeProductId(numericProductId));
                ("商品をお気に入りから削除しました");
              }

              // Save updated cache to localStorage
              saveFavouriteIds(Array.from(ids));
            } else {
              // Revert visual state if API failed
              this.classList.toggle("favourite-active");
            }
          })
          .catch((error) => {
            // Revert visual state if network error
            this.classList.toggle("favourite-active");
          })
          .finally(() => {
            // Re-enable button
            this.disabled = false;
          });
      });
    });

    // Add click handlers to custom navigation buttons
    const prevBtn = document.querySelector(
      ".similar-products-section .similar-nav-btn.prev-btn",
    );
    const nextBtn = document.querySelector(
      ".similar-products-section .similar-nav-btn.next-btn",
    );

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        ("🔍 Prev button clicked via event listener");
        if (swiperContainer && swiperContainer.swiper) {
          swiperContainer.swiper.slidePrev();
        } else {
          scrollSimilarProducts("prev");
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        if (swiperContainer && swiperContainer.swiper) {
          swiperContainer.swiper.slideNext();
        } else {
          scrollSimilarProducts("next");
        }
      });
    }

    // Ensure swiper is initialized after content is added
    setTimeout(() => {
      if (!swiperContainer.swiper) {
        // Try to trigger swiper initialization
        swiperContainer.initialize();
      } else {
      }
    }, 500);
  }

  // Duplicate function removed - now defined at top of file

  // Initialize product image slider and thumbnails
  function initializeProductImageSlider() {
    const mainSlider = document.querySelector(".product-image-slider");
    const thumbnailItems = document.querySelectorAll(".thumbnail-item");

    if (mainSlider && thumbnailItems.length > 0) {
      // Configure main slider
      Object.assign(mainSlider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: true,
      });

      mainSlider.swiper.on("slideChange", () => {
        const activeIndex = mainSlider.swiper.activeIndex;
        updateThumbnailActive(activeIndex);
        updateCustomPaginationCounter(activeIndex + 1);
      });

      // Handle thumbnail clicks
      thumbnailItems.forEach((item, index) => {
        item.addEventListener("click", () => {
          mainSlider.swiper.slideTo(index);
          updateThumbnailActive(index);
          updateCustomPaginationCounter(index + 1);
        });
      });

      // Initialize navigation buttons
      updateNavButtons();
    } else {
      // Missing elements for product image slider
    }
  }

  // Initialize similar products swiper on DOM ready (like home-slide-product-top)
  document.addEventListener("DOMContentLoaded", () => {
    const swiperEl = document.querySelector(".similar-products-swiper");
    if (swiperEl) {
      // Set up swiper configuration (like home-slide-product-top)
      Object.assign(swiperEl, {
        slidesPerView: "auto", // Auto width based on CSS
        spaceBetween: 16,
        loop: false, // Will be enabled later if enough products (6+)
        navigation: {
          enabled: false, // We use custom navigation
        },
        breakpoints: {
          320: { slidesPerView: "auto", spaceBetween: 10 },
          640: { slidesPerView: "auto", spaceBetween: 15 },
          768: { slidesPerView: "auto", spaceBetween: 16 },
          1024: { slidesPerView: "auto", spaceBetween: 16 },
        },
        on: {
          init: function () {},
        },
      });
    }
  });

  // Export functions for external use
  window.ProductDetail = {
    getSelectedQuantityRange: () => selectedQuantityRange,
    getSelectedPackaging: () => selectedPackaging,
    getMatrixData: () => matrixData,
    reRenderMatrix: () => {
      if (selectedQuantityRange) {
        renderStep3PriceMatrix();
      }
    },

    onSelectionChange: function (callback) {
      // This will be called whenever selection changes
      window.addEventListener("selectionChange", callback);
    },

    // Thumbnail navigation functions
    scrollThumbnails: scrollThumbnails,
    updateNavButtons: updateNavButtons,
    updateThumbnailActive: updateThumbnailActive,
    initializeProductImageSlider: initializeProductImageSlider,
    updateCustomPaginationCounter: updateCustomPaginationCounter,
  };
});
